import { preventBubblingEvent } from '@mote/helpers/browser'
import { KeyboardKey } from '@mote/helpers/constants'
import { Block } from '@mote/ui'
import React from 'react'
import styled, { css } from 'styled-components'
import { Emoji } from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { moteCardFluidDimensionsAdjuster } from './fluidSizing'

const EMOJIS_LIST = [
  {
    id: 0,
    emoji: '👍',
    value: 'thumbsUp',
    label: 'Thumbs up',
    description: 'Thumbs up!'
  },
  {
    id: 1,
    emoji: '🤔',
    value: 'thinking',
    label: 'Thinking',
    description: 'May need some time!'
  },
  {
    id: 2,
    emoji: '🤣',
    value: 'laugh',
    label: 'Laugh',
    description: 'This is funny!'
  },
  {
    id: 3,
    emoji: '💜',
    value: 'heart',
    label: 'Heart',
    description: 'Love this!'
  }
]

export function MoteCardRichEmojiPicker({ onEmojiSelected, myReactions }) {
  const { playerDimensions } = useMotePlayer()

  function handleEmojiSelection(emoji) {
    onEmojiSelected(emoji)
  }

  return (
    <Root
      layout='horizontal'
      margin={`${moteCardFluidDimensionsAdjuster(
        18,
        7,
        playerDimensions?.width
      )}px 0 0 0`}
    >
      {EMOJIS_LIST.map(({ id, emoji, label, value }) => (
        <StyledEmoji
          key={value}
          label={label}
          onClick={event => {
            preventBubblingEvent(event)
            handleEmojiSelection(value)
          }}
          onKeyDown={event => {
            switch (event.keyCode) {
              case KeyboardKey.Space:
              case KeyboardKey.Enter:
                preventBubblingEvent(event)
                handleEmojiSelection(value)
                break
            }
          }}
          selected={myReactions?.includes(value)}
          emojiSize={moteCardFluidDimensionsAdjuster(
            48,
            42,
            playerDimensions?.width
          )}
          fontSize={moteCardFluidDimensionsAdjuster(
            24,
            24,
            playerDimensions?.width
          )}
          isInteractive
        >
          {emoji}
        </StyledEmoji>
      ))}
    </Root>
  )
}

const Root = styled(Block)``

const StyledEmoji = styled(Emoji)`
  &:hover,
  &:focus {
    background: rgba(255, 255, 255, 0.2);
  }

  ${({ selected }) =>
    selected &&
    css`
      background: rgba(255, 255, 255, 1);

      span.emoji {
        transform: scale(1.2) !important;
      }
    `};
`
